import {
  otherAPIHeaders,
  uploadAPIHeaders,
} from "../shared-resources/dumpData";

export function getCapexRelatedExpenseBudgetDetailsAPI(year) {
  return fetch(
    `${process.env.KIRKLAND_APP_API_URL}/financial/getCapexRelatedExpenseBudgetDetails?financialYear=${year}`,
    {
      method: "POST",
      headers: otherAPIHeaders,
    },
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function getCapexRelatedExpenseForecastDetailsAPI(year) {
  return fetch(
    `${process.env.KIRKLAND_APP_API_URL}/financial/getCapexRelatedExpenseForecastDetails?financialYear=${year}`,
    {
      method: "POST",
      headers: otherAPIHeaders,
    },
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function getDirectEmployeeBudgetDetailsAPI(year) {
  return fetch(
    `${process.env.KIRKLAND_APP_API_URL}/financial/getDirectEmployeeBudgetDetails?financialYear=${year}`,
    {
      method: "POST",
      headers: otherAPIHeaders,
    },
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function getDirectEmployeeForecastDetailsAPI(year) {
  return fetch(
    `${process.env.KIRKLAND_APP_API_URL}/financial/getDirectEmployeeForecastDetails?financialYear=${year}`,
    {
      method: "POST",
      headers: otherAPIHeaders,
    },
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function getOtherDirectInHouseCostBudgetDetailsAPI(year) {
  return fetch(
    `${process.env.KIRKLAND_APP_API_URL}/financial/getOtherDirectInHouseCostBudgetDetails?financialYear=${year}`,
    {
      method: "POST",
      headers: otherAPIHeaders,
    },
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function getOtherDirectInHouseCostForecastDetailsAPI(year) {
  return fetch(
    `${process.env.KIRKLAND_APP_API_URL}/financial/getOtherDirectInHouseCostForecastDetails?financialYear=${year}`,
    {
      method: "POST",
      headers: otherAPIHeaders,
    },
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function getVendorEmployeeBudgetDetailsAPI(year) {
  return fetch(
    `${process.env.KIRKLAND_APP_API_URL}/financial/getVendorEmployeeBudgetDetails?financialYear=${year}`,
    {
      method: "POST",
      headers: otherAPIHeaders,
    },
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function getVendorEmployeeForecastDetailsAPI(year) {
  return fetch(
    `${process.env.KIRKLAND_APP_API_URL}/financial/getVendorEmployeeForecastDetails?financialYear=${year}`,
    {
      method: "POST",
      headers: otherAPIHeaders,
    },
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function getVendorRelatedCostBudgetDetailsAPI(year) {
  return fetch(
    `${process.env.KIRKLAND_APP_API_URL}/financial/getVendorRelatedCostBudgetDetails?financialYear=${year}`,
    {
      method: "POST",
      headers: otherAPIHeaders,
    },
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function getVendorRelatedCostForecastDetailsAPI(year) {
  return fetch(
    `${process.env.KIRKLAND_APP_API_URL}/financial/getVendorRelatedCostForecastDetails?financialYear=${year}`,
    {
      method: "POST",
      headers: otherAPIHeaders,
    },
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function createUpdateCapexRelatedExpenseBudgetDetailsAPI(body) {
  return fetch(
    `${process.env.KIRKLAND_APP_API_URL}/financial/createUpdateCapexRelatedExpenseBudgetDetails`,
    {
      method: "POST",
      headers: otherAPIHeaders,
      body: JSON.stringify(body),
    },
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function createUpdateCapexRelatedExpenseForecastDetailsAPI(body) {
  return fetch(
    `${process.env.KIRKLAND_APP_API_URL}/financial/createUpdateCapexRelatedExpenseForecastDetails`,
    {
      method: "POST",
      headers: otherAPIHeaders,
      body: JSON.stringify(body),
    },
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function createUpdateDirectEmployeeBudgetDetailsAPI(body) {
  return fetch(
    `${process.env.KIRKLAND_APP_API_URL}/financial/createUpdateDirectEmployeeBudgetDetails`,
    {
      method: "POST",
      headers: otherAPIHeaders,
      body: JSON.stringify(body),
    },
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function createUpdateDirectEmployeeForecastDetailsAPI(body) {
  return fetch(
    `${process.env.KIRKLAND_APP_API_URL}/financial/createUpdateDirectEmployeeForecastDetails`,
    {
      method: "POST",
      headers: otherAPIHeaders,
      body: JSON.stringify(body),
    },
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function createUpdateOtherDirectInHouseBudgetDetailsAPI(body) {
  return fetch(
    `${process.env.KIRKLAND_APP_API_URL}/financial/createUpdateOtherDirectInHouseBudgetDetails`,
    {
      method: "POST",
      headers: otherAPIHeaders,
      body: JSON.stringify(body),
    },
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function createUpdateOtherDirectInHouseForecastDetailsAPI(body) {
  return fetch(
    `${process.env.KIRKLAND_APP_API_URL}/financial/createUpdateOtherDirectInHouseForecastDetails`,
    {
      method: "POST",
      headers: otherAPIHeaders,
      body: JSON.stringify(body),
    },
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function createUpdateVendorEmploymentBudgetDetailsAPI(body) {
  return fetch(
    `${process.env.KIRKLAND_APP_API_URL}/financial/createUpdateVendorEmploymentBudgetDetails`,
    {
      method: "POST",
      headers: otherAPIHeaders,
      body: JSON.stringify(body),
    },
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function createUpdateVendorEmploymentForecastDetailsAPI(body) {
  return fetch(
    `${process.env.KIRKLAND_APP_API_URL}/financial/createUpdateVendorEmploymentForecastDetails`,
    {
      method: "POST",
      headers: otherAPIHeaders,
      body: JSON.stringify(body),
    },
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function createUpdateVendorRelatedCostBudgetDetailsAPI(body) {
  return fetch(
    `${process.env.KIRKLAND_APP_API_URL}/financial/createUpdateVendorRelatedCostBudgetDetails`,
    {
      method: "POST",
      headers: otherAPIHeaders,
      body: JSON.stringify(body),
    },
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function createUpdateVendorRelatedCostForecastDetailsAPI(body) {
  return fetch(
    `${process.env.KIRKLAND_APP_API_URL}/financial/createUpdateVendorRelatedCostForecastDetails`,
    {
      method: "POST",
      headers: otherAPIHeaders,
      body: JSON.stringify(body),
    },
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function getFinancialSummaryBudgetAPI(year) {
  return fetch(
    `${process.env.KIRKLAND_APP_API_URL}/financial/getFinancialSummaryBudget?financialYear=${year}`,
    {
      method: "GET",
      headers: otherAPIHeaders,
    },
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function getFinancialSummaryForecastAPI(year) {
  return fetch(
    `${process.env.KIRKLAND_APP_API_URL}/financial/getFinancialSummaryForecast?financialYear=${year}`,
    {
      method: "GET",
      headers: otherAPIHeaders,
    },
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function getBudgetVsForecastAPI(year) {
  return fetch(
    `${process.env.KIRKLAND_APP_API_URL}/financial/getBudgetVsForecast?financialYear=${year}`,
    {
      method: "GET",
      headers: otherAPIHeaders,
    },
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function getTopProjectVariancesListAPI(year) {
  return fetch(
    `${process.env.KIRKLAND_APP_API_URL}/financial/getTopProjectVariancesList?financialYear=${year}`,
    {
      method: "GET",
      headers: otherAPIHeaders,
    },
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function getProjectVariancesCostWaterfallAPI(year) {
  return fetch(
    `${process.env.KIRKLAND_APP_API_URL}/financial/getProjectVariancesCostWaterfall?financialYear=${year}`,
    {
      method: "GET",
      headers: otherAPIHeaders,
    },
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function getUpcomingDeadlinesAPI() {
  return fetch(
    `${process.env.KIRKLAND_APP_API_URL}/financial/getUpcomingDeadlines`,
    {
      method: "GET",
      headers: otherAPIHeaders,
    },
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function getContractSummaryAPI(contractId, version, financialYear) {
  return fetch(
    `${process.env.FINANCIAL_CLARITY_URL}/financial/contractSummary?contractId=${contractId}&version=${version}&financialYear=${financialYear}`,
    {
      method: "GET",
      headers: otherAPIHeaders,
    },
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function getContractSummaryCostPlusAPI(
  contractId,
  version,
  financialYear,
) {
  return fetch(
    `${process.env.FINANCIAL_CLARITY_URL}/financial/contractsummary-new/project-financials?contractId=${contractId}&version=${version}&financialYear=${financialYear}`,
    {
      method: "GET",
      headers: otherAPIHeaders,
    },
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function getContractSummaryEACAPI(contractId, year) {
  return fetch(
    `${process.env.FINANCIAL_CLARITY_URL}/financial/eacVsFunding?contractId=${contractId}`,
    {
      method: "GET",
      headers: otherAPIHeaders,
    },
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function getDirectLaborDetailsAPI(
  contractId,
  templateType,
  contractYear,
  version,
  financialYear,
) {
  return fetch(
    `${process.env.FINANCIAL_CLARITY_URL}/financial/directLaborDetails?templateType=${templateType}&contractId=${contractId}&version=${version}&financialYear=${financialYear}`,
    {
      method: "GET",
      headers: otherAPIHeaders,
    },
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function updateDirectLaborDetailsAPI(
  contractId,
  templateType,
  version,
  body,
  financialYear,
) {
  return fetch(
    `${process.env.FINANCIAL_CLARITY_URL}/financial/directLaborDetails?templateType=${templateType}&contractId=${contractId}&version=${version}&financialYear=${financialYear}`,
    {
      method: "PUT",
      headers: otherAPIHeaders,
      body: JSON.stringify(body),
    },
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function getOtherDirectCostsDetailsAPI(
  contractId,
  templateType,
  contractYear,
  version,
  financialYear,
) {
  return fetch(
    `${process.env.FINANCIAL_CLARITY_URL}/financial/otherDirectCostsDetails?templateType=${templateType}&contractId=${contractId}&version=${version}&financialYear=${financialYear}`,
    {
      method: "GET",
      headers: otherAPIHeaders,
    },
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function updateOtherDirectCostsDetailsAPI(
  contractId,
  templateType,
  contractYear,
  version,
  body,
  financialYear,
) {
  return fetch(
    `${process.env.FINANCIAL_CLARITY_URL}/financial/otherDirectCostsDetails?templateType=${templateType}&contractId=${contractId}&version=${version}&financialYear=${financialYear}`,
    {
      method: "POST",
      headers: otherAPIHeaders,
      body: JSON.stringify(body),
    },
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function getRevenueAPI(
  contractId,
  templateType,
  contractYear,
  version,
  financialYear,
) {
  return fetch(
    `${process.env.FINANCIAL_CLARITY_URL}/financial/revenue?templateType=${templateType}&contractId=${contractId}&version=${version}&financialYear=${financialYear}`,
    {
      method: "GET",
      headers: otherAPIHeaders,
    },
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function updateRevenueAPI(
  contractId,
  templateType,
  version,
  body,
  financialYear,
) {
  return fetch(
    `${process.env.FINANCIAL_CLARITY_URL}/financial/revenue?templateType=${templateType}&contractId=${contractId}&version=${version}&financialYear=${financialYear}`,
    {
      method: "PUT",
      headers: otherAPIHeaders,
      body: JSON.stringify(body),
    },
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function getMarginAPI(
  contractId,
  templateType,
  contractYear,
  version,
  financialYear,
) {
  return fetch(
    `${process.env.FINANCIAL_CLARITY_URL}/financial/margin?templateType=${templateType}&contractId=${contractId}&version=${version}&financialYear=${financialYear}`,
    {
      method: "GET",
      headers: otherAPIHeaders,
    },
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function updateMarginAPI(
  contractId,
  templateType,
  version = 1,
  body,
  financialYear,
) {
  return fetch(
    `${process.env.FINANCIAL_CLARITY_URL}/financial/margin?templateType=${templateType}&contractId=${contractId}&version=${version}&financialYear=${financialYear}`,
    {
      method: "PUT",
      headers: otherAPIHeaders,
      body: JSON.stringify(body),
    },
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function getDetailedViewRatesAPI(
  contractId,
  contractYear,
  financialYear,
  version,
) {
  return fetch(
    `${process.env.FINANCIAL_CLARITY_URL}/financial/detailedViewRates?&contractId=${contractId}&financialYear=${financialYear}&version=${version}`,
    {
      method: "GET",
      headers: otherAPIHeaders,
    },
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function getWeeklyEACClinDropdownAPI(contractId) {
  return fetch(
    `${process.env.FINANCIAL_CLARITY_URL}/financial/weekly-view/rvn-clins?contractId=${contractId}`,
    {
      method: "GET",
      headers: otherAPIHeaders,
    },
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function getWeeklyEACDirectLaborAPI(contractId, clin, version) {
  return fetch(
    `${process.env.FINANCIAL_CLARITY_URL}/financial/weekly-view/direct-labor?contractId=${contractId}&clin=${clin}&version=${version}`,
    {
      method: "GET",
      headers: otherAPIHeaders,
    },
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function downloadWeeklyEACDirectLaborAPI(contractId, clin, version) {
  return fetch(
    `${process.env.FINANCIAL_CLARITY_URL}/financial/weekly-view/direct-labor-excel?contractId=${contractId}&clin=${clin}&version=${version}`,
    {
      method: "GET",
      headers: otherAPIHeaders,
    },
  )
    .then((res) => res.blob())
    .catch((err) => err);
}

/** GET /financial/weekly-view/bulk-clin-summary-excel — one Excel file with the CLIN Summary
 *  block of every level-4 CLIN (Cost Plus/T&M/FFP, including .FOR CLINs) that has Weekly EAC
 *  data in the given calendar year. Success (200) is the binary workbook; failure (400, e.g. no
 *  CLIN has data that year) is the normal JSON error envelope — branch on Content-Type. See
 *  APIIntegrationFiles/WEEKLY_EAC_BULK_CLIN_SUMMARY_FRONTEND_GUIDE.md. */
export function downloadWeeklyEACBulkClinSummaryAPI(contractId, year, version) {
  return fetch(
    `${process.env.FINANCIAL_CLARITY_URL}/financial/weekly-view/bulk-clin-summary-excel?contractId=${contractId}&year=${year}&version=${version}`,
    {
      method: "GET",
      headers: otherAPIHeaders,
    },
  )
    .then((res) => {
      const contentType = res.headers.get("content-type") || "";
      if (contentType.includes("application/json")) {
        return res.json();
      }
      return res.blob().then((blob) => ({ status: 200, isFile: true, blob }));
    })
    .catch((err) => err);
}

/** GET /financial/weekly-view/download-template — editable .xlsx of forecast-only
 *  Direct Labor/ODC/COCR buckets for one CLIN/version, for offline bulk editing.
 *  See docs/api/weekly-eac-template-download.md. */
export function downloadWeeklyEACTemplateAPI(contractId, clin, version) {
  return fetch(
    `${process.env.FINANCIAL_CLARITY_URL}/financial/weekly-view/download-template?contractId=${contractId}&clin=${clin}&version=${version}`,
    {
      method: "GET",
      headers: otherAPIHeaders,
    },
  )
    .then((res) => res.blob())
    .catch((err) => err);
}

/** POST /financial/weekly-view/upload-template — uploads an edited copy of the
 *  download-template workbook; `version` must be "Open". Returns the same
 *  workbook with a "Result" sheet appended (Saved/Skipped per edited cell), as
 *  a binary stream — same file-in/file-out shape as uploadDetailedViewAPI above.
 *  See docs/api/weekly-eac-template-upload.md. */
export function uploadWeeklyEACTemplateAPI(contractId, clin, version, body) {
  return fetch(
    `${process.env.FINANCIAL_CLARITY_URL}/financial/weekly-view/upload-template?contractId=${contractId}&clin=${clin}&version=${version}`,
    {
      method: "POST",
      headers: uploadAPIHeaders,
      body: body,
    },
  )
    .then((res) =>
      res.blob().then((blob) => ({
        status: res.status,
        type: blob.type,
        blob: blob,
      })),
    )
    .catch((err) => err);
}

export function updateWeeklyEACDirectLaborAPI(contractId, clin, version, body) {
  return fetch(
    `${process.env.FINANCIAL_CLARITY_URL}/financial/weekly-view/direct-labor?contractId=${contractId}&clin=${clin}&version=${version}`,
    {
      method: "PUT",
      headers: otherAPIHeaders,
      body: JSON.stringify(body),
    },
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function getDropdownOptionsAPI(contractId, version, financialYear) {
  return fetch(
    `${process.env.FINANCIAL_CLARITY_URL}/financial/dropdownOptions?contractId=${contractId}&version=${version}&financialYear=${financialYear}`,
    {
      method: "GET",
      headers: otherAPIHeaders,
    },
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function updateDetailedViewRatesAPI(
  contractId,
  templateType,
  body,
  financialYear,
  version,
) {
  return fetch(
    `${process.env.FINANCIAL_CLARITY_URL}/financial/detailedViewRates?templateType=${templateType}&contractId=${contractId}&financialYear=${financialYear}&version=${version}`,
    {
      method: "PUT",
      headers: otherAPIHeaders,
      body: JSON.stringify(body),
    },
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function getListOfContractsAPI() {
  return fetch(
    `${process.env.FINANCIAL_CLARITY_URL}/financial/listOfContracts`,
    {
      method: "GET",
      headers: {
        ...otherAPIHeaders,
        empId: localStorage.getItem("employeeId"),
      },
    },
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function getListOfVersionsAPI(contractId) {
  return fetch(
    `${process.env.FINANCIAL_CLARITY_URL}/financial/contractYearVersion?contractId=${contractId}`,
    {
      method: "GET",
      headers: otherAPIHeaders,
    },
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function downloadDetailedViewAPI(
  contractId,
  templateType,
  contractYear,
  version,
  financialYear,
) {
  return fetch(
    `${process.env.FINANCIAL_CLARITY_URL}/financial/detailed-view-excel?contractId=${contractId}&templateType=${templateType}&version=${version}&financialYear=${financialYear}`,
    {
      method: "GET",
      headers: otherAPIHeaders,
    },
  )
    .then((res) => res.blob())
    .catch((err) => err);
}

export function getRvnLvlClinListAPI(contractId) {
  return fetch(
    `${process.env.FINANCIAL_CLARITY_URL}/financial/getRvnLvlClinList?contractId=${contractId}`,
    {
      method: "GET",
      headers: otherAPIHeaders,
    },
  )
    .then((res) => res.json())
    .catch((err) => err);
}

/* See APIIntegrationFiles/psr-trend-download.md. financialYear is omitted (all years); `clins`
   goes in the POST body. */
export function downloadPsrAPI(contractId, version, clins = []) {
  return fetch(
    `${process.env.FINANCIAL_CLARITY_URL}/financial/new-psr/downloadPsrTrend?contractId=${contractId}&version=${version}`,
    {
      method: "POST",
      headers: { ...otherAPIHeaders, ["Content-Type"]: "application/json" },
      body: JSON.stringify({ clins }),
    },
  )
    .then((res) => res.blob())
    .catch((err) => err);
}

export function downloadDetailedViewTemplateAPI(
  contractId,
  templateType,
  version,
  financialYear,
) {
  return fetch(
    `${process.env.FINANCIAL_CLARITY_URL}/financial/downloadDetailedViewTemplate?contractId=${contractId}&templateType=${templateType}&version=${version}&financialYear=${financialYear}`,
    {
      method: "GET",
      headers: otherAPIHeaders,
    },
  )
    .then((res) => res.blob())
    .catch((err) => err);
}

export function downloadOpportunityListAPI(oppNos) {
  return fetch(
    `${process.env.FINANCIAL_CLARITY_URL}/financial/pipeline/downloadOpportunityList`,
    {
      method: "POST",
      headers: { ...otherAPIHeaders, ["Content-Type"]: "application/json" },
      body: JSON.stringify({ oppNos: oppNos || [] }),
    },
  )
    .then((res) => res.blob())
    .catch((err) => err);
}

export function uploadDetailedViewAPI(
  contractId,
  templateType,
  version,
  body,
  financialYear,
) {
  return fetch(
    `${process.env.FINANCIAL_CLARITY_URL}/financial/updateDetailedViewFromExcel?contractId=${contractId}&templateType=${templateType}&version=${version}&financialYear=${financialYear}`,
    {
      method: "POST",
      headers: uploadAPIHeaders,
      body: body,
    },
  )
    .then((res) =>
      res.blob().then((blob) => ({
        status: res.status,
        type: blob.type,
        blob: blob,
      })),
    )
    .catch((err) => err);
}
export function getFinancialYearSettingsAPI() {
  return fetch(
    `${process.env.FINANCIAL_CLARITY_URL}/financial/financial-year-settings`,
    {
      method: "GET",
      headers: otherAPIHeaders,
    },
  )
    .then((res) => res.json())
    .catch((err) => err);
}
export function getRvnClinDropdown(contractId) {
  return fetch(
    `${process.env.FINANCIAL_CLARITY_URL}/financial/getRvnClinDropdown?contractId=${contractId}`,
    {
      method: "GET",
      headers: otherAPIHeaders,
    },
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function getFinancialYearsAPI(fvsId) {
  return fetch(
    `${process.env.FINANCIAL_CLARITY_URL}/financial/financial-year?fvsId=${fvsId}`,
    {
      method: "GET",
      headers: otherAPIHeaders,
    },
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function createFinancialYearVersionAPI(body) {
  return fetch(
    `${process.env.FINANCIAL_CLARITY_URL}/financial/financial-year-version`,
    {
      method: "POST",
      headers: otherAPIHeaders,
      body: JSON.stringify(body),
    },
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function updateFinancialVersionAPI(body) {
  return fetch(
    `${process.env.FINANCIAL_CLARITY_URL}/financial/financial-version-controll`,
    {
      method: "PUT",
      headers: otherAPIHeaders,
      body: JSON.stringify(body),
    },
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function getPSRRevenueAPI(contractId, version, financialYear) {
  return fetch(
    `${process.env.FINANCIAL_CLARITY_URL}/financial/new-psr/revenue?contractId=${contractId}&version=${version}&financialYear=${financialYear}`,
    {
      method: "GET",
      headers: otherAPIHeaders,
    },
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function getPSRDirectLaborAPI(contractId, version, financialYear) {
  return fetch(
    `${process.env.FINANCIAL_CLARITY_URL}/financial/new-psr/directLabor?contractId=${contractId}&version=${version}&financialYear=${financialYear}`,
    {
      method: "GET",
      headers: otherAPIHeaders,
    },
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function getPSRsubcontractorAPI(contractId, version, financialYear) {
  return fetch(
    `${process.env.FINANCIAL_CLARITY_URL}/financial/new-psr/subContactor?contractId=${contractId}&version=${version}&financialYear=${financialYear}`,
    {
      method: "GET",
      headers: otherAPIHeaders,
    },
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function getPSRotherdirectcostsAPI(contractId, version, financialYear) {
  return fetch(
    `${process.env.FINANCIAL_CLARITY_URL}/financial/new-psr/otherDirectCosts?contractId=${contractId}&version=${version}&financialYear=${financialYear}`,
    {
      method: "GET",
      headers: otherAPIHeaders,
    },
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function getPSRotherdirectcostsTotalAPI(
  contractId,
  version,
  financialYear,
) {
  return fetch(
    `${process.env.FINANCIAL_CLARITY_URL}/financial/new-psr/totalDirectCost?contractId=${contractId}&version=${version}&financialYear=${financialYear}`,
    {
      method: "GET",
      headers: otherAPIHeaders,
    },
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function getPSRindirectcostsAPI(contractId, version, financialYear) {
  return fetch(
    `${process.env.FINANCIAL_CLARITY_URL}/financial/new-psr/indirectCosts?contractId=${contractId}&version=${version}&financialYear=${financialYear}`,
    {
      method: "GET",
      headers: otherAPIHeaders,
    },
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function getPSRTotalCostsAPI(contractId, version, financialYear) {
  return fetch(
    `${process.env.FINANCIAL_CLARITY_URL}/financial/new-psr/totalCost?contractId=${contractId}&version=${version}&financialYear=${financialYear}`,
    {
      method: "GET",
      headers: otherAPIHeaders,
    },
  )
    .then((res) => res.json())
    .catch((err) => err);
}
export function updatePsrRevenueVariance(
  contractId,
  version,
  financialYear,
  body,
) {
  return fetch(
    `${process.env.FINANCIAL_CLARITY_URL}/financial/new-psr/updatePsrRevenueVariance?contractId=${contractId}&version=${version}&financialYear=${financialYear}`,
    {
      method: "PUT",
      headers: otherAPIHeaders,
      body: JSON.stringify(body),
    },
  )
    .then((res) => res.json())
    .catch((err) => err);
}
export function updatePsrIndirectVariance(
  contractId,
  version,
  financialYear,
  body,
) {
  return fetch(
    `${process.env.FINANCIAL_CLARITY_URL}/financial/new-psr/updatePsrIndirectVariance?contractId=${contractId}&version=${version}&financialYear=${financialYear}`,
    {
      method: "PUT",
      headers: otherAPIHeaders,
      body: JSON.stringify(body),
    },
  )
    .then((res) => res.json())
    .catch((err) => err);
}
export function postPsrIndirectVariance(body) {
  return fetch(
    `${process.env.FINANCIAL_CLARITY_URL}/financial/new-psr/createPsrIndirectVariance`,
    {
      method: "PUT",
      headers: otherAPIHeaders,
      body: JSON.stringify(body),
    },
  )
    .then((res) => res.json())
    .catch((err) => err);
}
export function postPsrRevenueVariance(body) {
  return fetch(
    `${process.env.FINANCIAL_CLARITY_URL}/financial/new-psr/createPsrRevenueVariance`,
    {
      method: "PUT",
      headers: otherAPIHeaders,
      body: JSON.stringify(body),
    },
  )
    .then((res) => res.json())
    .catch((err) => err);
}
export function getIndirectLaborODCAPI(body) {
  return fetch(
    `${process.env.FINANCIAL_CLARITY_URL}/financial/indirect/get-labor-odc`,
    {
      method: "POST",
      headers: otherAPIHeaders,
      body: JSON.stringify(body),
    },
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function getIndirectLaborAPI(body) {
  return fetch(
    `${process.env.FINANCIAL_CLARITY_URL}/financial/indirect/get-indirect-labor`,
    {
      method: "POST",
      headers: otherAPIHeaders,
      body: JSON.stringify(body),
    },
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function downloadIndirectLaborAPI(body) {
  return fetch(
    `${process.env.FINANCIAL_CLARITY_URL}/financial/indirect/download-indirect-labor`,
    {
      method: "POST",
      headers: otherAPIHeaders,
      body: JSON.stringify(body),
    },
  )
    .then((res) => res.blob())
    .catch((err) => err);
}
export function deleteIndirectLaborAPI(id) {
  return fetch(
    `${process.env.FINANCIAL_CLARITY_URL}/financial/indirect/delete-labor-forecast?id=${id}`,
    {
      method: "DELETE",
      headers: otherAPIHeaders,
    },
  )
    .then((res) => res.json())
    .catch((err) => err);
}
export function deleteIndirectNonLaborAPI(id) {
  return fetch(
    `${process.env.FINANCIAL_CLARITY_URL}/financial/indirect/delete-non-labor-forecast?id=${id}`,
    {
      method: "DELETE",
      headers: otherAPIHeaders,
    },
  )
    .then((res) => res.json())
    .catch((err) => err);
}

/** POST /financial/indirect/plan-file — uploads an Excel plan-file attachment against the
 *  budget version (multipart: file, version, department?, subDepartment?). Stored as-is, no
 *  parsing (Phase 1). Multiple uploads are additive — nothing is replaced. Only accepted while
 *  `version` is currently editable; a locked version 400s.
 *  See APIIntegrationFiles/INDIRECT_BUDGET_VERSION_FRONTEND_GUIDE.md §4. */
export function uploadIndirectPlanFileAPI(body) {
  return fetch(
    `${process.env.FINANCIAL_CLARITY_URL}/financial/indirect/plan-file`,
    {
      method: "POST",
      headers: uploadAPIHeaders,
      body: body,
    },
  )
    .then((res) => res.json())
    .catch((err) => err);
}

/** GET /financial/indirect/plan-file?version={version}&department={department} — metadata list
 *  only (no file content) of every plan-file previously uploaded against that version. As of
 *  2026-10-19, `department` is required — pass the same department value already sent to the
 *  other indirect endpoints, or "ALL-CORP" for the corp-wide view. Attachments are scoped per
 *  department, so each department only sees its own uploads. */
export function getIndirectPlanFilesAPI(version, department) {
  return fetch(
    `${process.env.FINANCIAL_CLARITY_URL}/financial/indirect/plan-file?version=${version}&department=${department}`,
    {
      method: "GET",
      headers: otherAPIHeaders,
    },
  )
    .then((res) => res.json())
    .catch((err) => err);
}

/** GET /financial/indirect/plan-file/download/{id} — the raw uploaded file, binary. */
export function downloadIndirectPlanFileAPI(id) {
  return fetch(
    `${process.env.FINANCIAL_CLARITY_URL}/financial/indirect/plan-file/download/${id}`,
    {
      method: "GET",
      headers: otherAPIHeaders,
    },
  )
    .then((res) => res.blob())
    .catch((err) => err);
}

/** DELETE /financial/indirect/plan-file/{id} — permanently removes one plan-file attachment
 *  (hard delete, no undo). Same editable-budget-version gate as upload; a locked version or an
 *  unknown id both 400 cleanly. See
 *  APIIntegrationFiles/INDIRECT_BUDGET_VERSION_FRONTEND_GUIDE.md §4 (2026-09-22 update). */
export function deleteIndirectPlanFileAPI(id) {
  return fetch(
    `${process.env.FINANCIAL_CLARITY_URL}/financial/indirect/plan-file/${id}`,
    {
      method: "DELETE",
      headers: otherAPIHeaders,
    },
  )
    .then((res) => res.json())
    .catch((err) => err);
}

/** POST /financial/indirect/plan-file/import-non-labor — uploads a filled-in budget workbook and
 *  applies its "Indirect Non-Labor" sheet to the version's non-labor forecast (multipart: file,
 *  version, department?, subDepartment?). Also stores the file as a plan-file attachment, same as
 *  uploadIndirectPlanFileAPI. On success (200) the response body is the binary result workbook,
 *  not JSON; on failure (400) it's the normal JSON error envelope — branch on Content-Type. See
 *  APIIntegrationFiles/INDIRECT_NONLABOR_UPLOAD_FRONTEND_GUIDE.md. */
export function uploadIndirectNonLaborDataAPI(body) {
  return fetch(
    `${process.env.FINANCIAL_CLARITY_URL}/financial/indirect/plan-file/import-non-labor`,
    {
      method: "POST",
      headers: uploadAPIHeaders,
      body: body,
    },
  )
    .then((res) => {
      const contentType = res.headers.get("content-type") || "";
      if (contentType.includes("application/json")) {
        return res.json();
      }
      return res.blob().then((blob) => ({ status: 200, isFile: true, blob }));
    })
    .catch((err) => err);
}

/** GET /financial/indirect/plan-file/template?financialYear={year} — a blank .xlsx matching the
 *  columns uploadIndirectNonLaborDataAPI expects (Department, Project ID, Account ID, Notes, 12
 *  monthly columns for that year). Read-only, no version gate. Success (200) is the binary
 *  workbook; failure (400, e.g. financialYear out of range) is the normal JSON error envelope —
 *  branch on Content-Type, same as uploadIndirectNonLaborDataAPI. See
 *  APIIntegrationFiles/INDIRECT_NONLABOR_UPLOAD_FRONTEND_GUIDE.md §3. */
export function downloadIndirectNonLaborTemplateAPI(financialYear) {
  return fetch(
    `${process.env.FINANCIAL_CLARITY_URL}/financial/indirect/plan-file/template?financialYear=${financialYear}`,
    {
      method: "GET",
      headers: otherAPIHeaders,
    },
  )
    .then((res) => {
      const contentType = res.headers.get("content-type") || "";
      if (contentType.includes("application/json")) {
        return res.json();
      }
      return res.blob().then((blob) => ({ status: 200, isFile: true, blob }));
    })
    .catch((err) => err);
}

/** Fringe's own plan-file attachments — same shape as Indirect's, but separate storage (fringe
 *  files never show up in the Indirect list and vice versa); no department/subDepartment, only
 *  an optional `financialYear` filter context. See
 *  APIIntegrationFiles/FRINGE_BUDGET_VERSION_FRONTEND_GUIDE.md §4. */
export function uploadFringePlanFileAPI(body) {
  return fetch(
    `${process.env.FINANCIAL_CLARITY_URL}/financial/indirect/fringe-plan-file`,
    {
      method: "POST",
      headers: uploadAPIHeaders,
      body: body,
    },
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function getFringePlanFilesAPI(version) {
  return fetch(
    `${process.env.FINANCIAL_CLARITY_URL}/financial/indirect/fringe-plan-file?version=${version}`,
    {
      method: "GET",
      headers: otherAPIHeaders,
    },
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function downloadFringePlanFileAPI(id) {
  return fetch(
    `${process.env.FINANCIAL_CLARITY_URL}/financial/indirect/fringe-plan-file/download/${id}`,
    {
      method: "GET",
      headers: otherAPIHeaders,
    },
  )
    .then((res) => res.blob())
    .catch((err) => err);
}

export function deleteFringePlanFileAPI(id) {
  return fetch(
    `${process.env.FINANCIAL_CLARITY_URL}/financial/indirect/fringe-plan-file/${id}`,
    {
      method: "DELETE",
      headers: otherAPIHeaders,
    },
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function getIndirectNonLaborODCAPI(body) {
  return fetch(
    `${process.env.FINANCIAL_CLARITY_URL}/financial/indirect/get-non-labor-odc`,
    {
      method: "POST",
      headers: otherAPIHeaders,
      body: JSON.stringify(body),
    },
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function getIndirectHeaderAPI(selectedYear, selectedVersion) {
  return fetch(
    `${process.env.FINANCIAL_CLARITY_URL}/financial/indirect/indirect-header?financialYear=${selectedYear}&version=${selectedVersion}`,
    {
      method: "GET",
      headers: otherAPIHeaders,
    },
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function updateIndirectLaborODCAPI(body, selectedVersion) {
  return fetch(
    `${process.env.FINANCIAL_CLARITY_URL}/financial/indirect/post-labor-odc?version=${selectedVersion}`,
    {
      method: "POST",
      headers: otherAPIHeaders,
      body: JSON.stringify(body),
    },
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function updateIndirectLaborAPI(body, selectedVersion) {
  return fetch(
    `${process.env.FINANCIAL_CLARITY_URL}/financial/indirect/post-indirect-labor?version=${selectedVersion}`,
    {
      method: "POST",
      headers: otherAPIHeaders,
      body: JSON.stringify(body),
    },
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function getIndirectDropdownsAPI() {
  return fetch(
    `${process.env.FINANCIAL_CLARITY_URL}/financial/indirect/indirect-dropdown`,
    {
      method: "GET",
      headers: otherAPIHeaders,
    },
  )
    .then((res) => res.json())
    .catch((err) => err);
}
export function postProjectDropdownAPI(body) {
  return fetch(
    `${process.env.FINANCIAL_CLARITY_URL}/financial/indirect/project-dropdown`,
    {
      method: "POST",
      headers: otherAPIHeaders,
      body: JSON.stringify(body),
    },
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function getAccountDropdownAPI(type) {
  return fetch(
    `${process.env.FINANCIAL_CLARITY_URL}/financial/indirect/account-dropdown?type=${type}`,
    {
      method: "GET",
      headers: otherAPIHeaders,
    },
  )
    .then((res) => res.json())
    .catch((err) => err);
}
export function getEmployeeDropdownAPI() {
  return fetch(
    `${process.env.FINANCIAL_CLARITY_URL}/financial/indirect/employee-dropdown`,
    {
      method: "GET",
      headers: otherAPIHeaders,
    },
  )
    .then((res) => res.json())
    .catch((err) => err);
}
export function getFringeDropdownAPI() {
  return fetch(
    `${process.env.FINANCIAL_CLARITY_URL}/financial/indirect/fringe-dropdown`,
    {
      method: "GET",
      headers: otherAPIHeaders,
    },
  )
    .then((res) => res.json())
    .catch((err) => err);
}
export function getFringeHeaderAPI(financialYear, selectedVersion) {
  return fetch(
    `${process.env.FINANCIAL_CLARITY_URL}/financial/indirect/fringe-header?financialYear=${financialYear}&version=${selectedVersion}`,
    {
      method: "GET",
      headers: otherAPIHeaders,
    },
  )
    .then((res) => res.json())
    .catch((err) => err);
}
export function getFringeAPI(financialYear, selectedVersion) {
  return fetch(
    `${process.env.FINANCIAL_CLARITY_URL}/financial/indirect/fringe?financialYear=${financialYear}&version=${selectedVersion}`,
    {
      method: "GET",
      headers: otherAPIHeaders,
    },
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function downloadFringeAPI(financialYear, selectedVersion) {
  return fetch(
    `${process.env.FINANCIAL_CLARITY_URL}/financial/indirect/download-fringe`,
    {
      method: "POST",
      headers: otherAPIHeaders,
      body: JSON.stringify({
        financialYear,
        version: selectedVersion,
      }),
    },
  )
    .then((res) => res.blob())
    .catch((err) => err);
}
/** `version` is optional — omit it (or pass a falsy value) to keep the pre-existing behavior of
 *  creating the row in the current Open version. Pass the currently-selected version's id to
 *  create it there instead (needed to add a fringe row against the editable budget version).
 *  See FRINGE_BUDGET_VERSION_FRONTEND_GUIDE.md §3. */
export function postFringeAPI(body, version) {
  const query = version || version === 0 ? `?version=${version}` : "";
  return fetch(
    `${process.env.FINANCIAL_CLARITY_URL}/financial/indirect/fringe${query}`,
    {
      method: "POST",
      headers: otherAPIHeaders,
      body: JSON.stringify(body),
    },
  )
    .then((res) => res.json())
    .catch((err) => err);
}
export function updateFringeAPI(selectedVersion, body) {
  return fetch(
    `${process.env.FINANCIAL_CLARITY_URL}/financial/indirect/fringe?version=${selectedVersion}`,
    {
      method: "PUT",
      headers: otherAPIHeaders,
      body: JSON.stringify(body),
    },
  )
    .then((res) => res.json())
    .catch((err) => err);
}
export function updateFringenotesAPI(body) {
  return fetch(
    `${process.env.FINANCIAL_CLARITY_URL}/financial/indirect/update-fringe-notes`,
    {
      method: "PUT",
      headers: otherAPIHeaders,
      body: JSON.stringify(body),
    },
  )
    .then((res) => res.json())
    .catch((err) => err);
}
export function deleteFringeAPI(dlId) {
  return fetch(
    `${process.env.FINANCIAL_CLARITY_URL}/financial/indirect/fringe?id=${dlId}`,
    {
      method: "DELETE",
      headers: otherAPIHeaders,
    },
  )
    .then((res) => res.json())
    .catch((err) => err);
}
export function updateLaborNotesAPI(body) {
  return fetch(
    `${process.env.FINANCIAL_CLARITY_URL}/financial/indirect/update-labor-notes`,
    {
      method: "POST",
      headers: otherAPIHeaders,
      body: JSON.stringify(body),
    },
  )
    .then((res) => res.json())
    .catch((err) => err);
}
export function updateNonLaborNotesAPI(body) {
  return fetch(
    `${process.env.FINANCIAL_CLARITY_URL}/financial/indirect/update-nonlabor-notes`,
    {
      method: "POST",
      headers: otherAPIHeaders,
      body: JSON.stringify(body),
    },
  )
    .then((res) => res.json())
    .catch((err) => err);
}
// DeleteNoteRequest body: { id, noteIndex } — id is the labor/fringe/nonlabor record's own id,
// noteIndex is the entry's position in that record's notes list (not the reversed, newest-first
// order the UI displays the history in).
export function deleteLaborNoteAPI(body) {
  return fetch(
    `${process.env.FINANCIAL_CLARITY_URL}/financial/indirect/delete-labor-note`,
    {
      method: "DELETE",
      headers: otherAPIHeaders,
      body: JSON.stringify(body),
    },
  )
    .then((res) => res.json())
    .catch((err) => err);
}
export function deleteFringeNoteAPI(body) {
  return fetch(
    `${process.env.FINANCIAL_CLARITY_URL}/financial/indirect/delete-fringe-note`,
    {
      method: "DELETE",
      headers: otherAPIHeaders,
      body: JSON.stringify(body),
    },
  )
    .then((res) => res.json())
    .catch((err) => err);
}
export function deleteNonLaborNoteAPI(body) {
  return fetch(
    `${process.env.FINANCIAL_CLARITY_URL}/financial/indirect/delete-nonlabor-note`,
    {
      method: "DELETE",
      headers: otherAPIHeaders,
      body: JSON.stringify(body),
    },
  )
    .then((res) => res.json())
    .catch((err) => err);
}
export function createNewLaborAPI(body, selectedVersion) {
  return fetch(
    `${process.env.FINANCIAL_CLARITY_URL}/financial/indirect/create-labor-forecast?version=${selectedVersion}`,
    {
      method: "POST",
      headers: otherAPIHeaders,
      body: JSON.stringify(body),
    },
  )
    .then((res) => res.json())
    .catch((err) => err);
}
export function createNewNonLaborAPI(body, financialYear, selectedVersion) {
  return fetch(
    `${process.env.FINANCIAL_CLARITY_URL}/financial/indirect/create-non-labor-forecast?financialYear=${financialYear}&version=${selectedVersion}`,
    {
      method: "POST",
      headers: otherAPIHeaders,
      body: JSON.stringify(body),
    },
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function getProjectClinsAPI(
  contractId,
  templateType,
  version,
  financialYear,
) {
  return fetch(
    `${process.env.FINANCIAL_CLARITY_URL}/financial/lcat-information?contractId=${contractId}&templateType=${templateType}&version=${version}&financialYear=${financialYear}`,
    {
      method: "GET",
      headers: otherAPIHeaders,
    },
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function getAddResourceDetailsForContractAPI() {
  return fetch(
    `${process.env.FINANCIAL_CLARITY_URL}/financial/getAddResourceDetailsForContract`,
    {
      method: "GET",
      headers: otherAPIHeaders,
    },
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function addResourceToContractAPI(body, version, financialYear) {
  return fetch(
    `${process.env.FINANCIAL_CLARITY_URL}/financial/addResourceToContract?version=${version}&financialYear=${financialYear}`,
    {
      method: "POST",
      headers: otherAPIHeaders,
      body: JSON.stringify(body),
    },
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function unnamedResourceNotesAPI(body) {
  return fetch(
    `${process.env.FINANCIAL_CLARITY_URL}/financial/unnamedResourceNotes`,
    {
      method: "PUT",
      headers: otherAPIHeaders,
      body: JSON.stringify(body),
    },
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function getDetailedViewHeadersAPI(
  contractId,
  templateType,
  version,
  financialYear,
) {
  return fetch(
    `${process.env.FINANCIAL_CLARITY_URL}/financial/getDetailedViewHeaders?contractId=${contractId}&templateType=${templateType}&version=${version}&financialYear=${financialYear}`,
    {
      method: "GET",
      headers: otherAPIHeaders,
    },
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function updateContractClinRatesAPI(body, version, financialYear) {
  return fetch(
    `${process.env.FINANCIAL_CLARITY_URL}/financial/contract-clin-rates?version=${version}&financialYear=${financialYear}`,
    {
      method: "PUT",
      headers: otherAPIHeaders,
      body: JSON.stringify(body),
    },
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function getContractClinRatesAPI(
  contractId,
  templateType,
  version,
  financialYear,
) {
  return fetch(
    `${process.env.FINANCIAL_CLARITY_URL}/financial/contract-clin-rates?contractId=${contractId}&templateType=${templateType}&version=${version}&financialYear=${financialYear}`,
    {
      method: "GET",
      headers: otherAPIHeaders,
    },
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function getPSRHeadersAPI(contractId, version, financialYear) {
  return fetch(
    `${process.env.FINANCIAL_CLARITY_URL}/financial/new-psr/getPSRHeaders?contractId=${contractId}&version=${version}&financialYear=${financialYear}`,
    {
      method: "GET",
      headers: otherAPIHeaders,
    },
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function getClinsForOdcAPI(
  contractId,
  templateType,
  version,
  financialYear,
) {
  return fetch(
    `${process.env.FINANCIAL_CLARITY_URL}/financial/getClinsForOdc?contractId=${contractId}&templateType=${templateType}&version=${version}&financialYear=${financialYear}`,
    {
      method: "GET",
      headers: otherAPIHeaders,
    },
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function addNewOdcAPI(body, version, financialYear) {
  return fetch(
    `${process.env.FINANCIAL_CLARITY_URL}/financial/addNewOdc?version=${version}&financialYear=${financialYear}`,
    {
      method: "POST",
      headers: otherAPIHeaders,
      body: JSON.stringify(body),
    },
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function deleteUnnamedResourceAPI(contractId, templateType, dlId) {
  return fetch(
    `${process.env.FINANCIAL_CLARITY_URL}/financial/unnamedResource?contractId=${contractId}&templateType=${templateType}&dlId=${dlId}`,
    {
      method: "DELETE",
      headers: otherAPIHeaders,
    },
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function deleteODCAPI(templateType, odlId) {
  return fetch(
    `${process.env.FINANCIAL_CLARITY_URL}/financial/odc?templateType=${templateType}&odlId=${odlId}`,
    {
      method: "DELETE",
      headers: otherAPIHeaders,
    },
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function updateClinRevisedEndDateAPI(body, version, financialYear) {
  return fetch(
    `${process.env.FINANCIAL_CLARITY_URL}/financial/clinRevisedEndDate?version=${version}&financialYear=${financialYear}`,
    {
      method: "PUT",
      headers: otherAPIHeaders,
      body: JSON.stringify(body),
    },
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function getFinancialYearOptionsAPI(contractId, version, templateType) {
  return fetch(
    `${process.env.FINANCIAL_CLARITY_URL}/financial/getFinancialYearOptions?templateType=${templateType}&contractId=${contractId}&version=${version}`,
    {
      method: "GET",
      headers: otherAPIHeaders,
    },
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function getFinancialYearOptionsPSRAPI(contractId, version) {
  return fetch(
    `${process.env.FINANCIAL_CLARITY_URL}/financial/new-psr/getFinancialYearOptionsPSR?contractId=${contractId}&version=${version}`,
    {
      method: "GET",
      headers: otherAPIHeaders,
    },
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function getHeatMapAPI(contractId) {
  return fetch(
    `${process.env.FINANCIAL_CLARITY_URL}/financial/heatMap?contractId=${contractId}`,
    {
      method: "GET",
      headers: otherAPIHeaders,
    },
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function updateHeatMapAPI(body, contractId) {
  return fetch(
    `${process.env.FINANCIAL_CLARITY_URL}/financial/heatMap?contractId=${contractId}`,
    {
      method: "PUT",
      headers: otherAPIHeaders,
      body: JSON.stringify(body),
    },
  )
    .then((res) => res.json())
    .catch((err) => err);
}
export function getClinLevelDetailsAPI(contractId, version) {
  return fetch(
    `${process.env.FINANCIAL_CLARITY_URL}/financial/clinLevelDetails?contractId=${contractId}&version=${version}`,
    {
      method: "GET",
      headers: otherAPIHeaders,
    },
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function updateClinLevelDetailsAPI(body, contractId, version) {
  return fetch(
    `${process.env.FINANCIAL_CLARITY_URL}/financial/clinLevelDetails?contractId=${contractId}&version=${version}`,
    {
      method: "PUT",
      headers: otherAPIHeaders,
      body: JSON.stringify(body),
    },
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function getAssumptionAPI(contractId, version) {
  return fetch(
    `${process.env.FINANCIAL_CLARITY_URL}/financial/contractAssumption?contractId=${contractId}&version=${version}`,
    {
      method: "GET",
      headers: otherAPIHeaders,
    },
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function updateAssumptionAPI(body) {
  return fetch(
    `${process.env.FINANCIAL_CLARITY_URL}/financial/contractAssumption`,
    {
      method: "PUT",
      headers: otherAPIHeaders,
      body: JSON.stringify(body),
    },
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function getListOfOpportunityAPI() {
  return fetch(
    `${process.env.FINANCIAL_CLARITY_URL}/financial/pipeline/getListOfOpportunity`,
    {
      method: "GET",
      headers: otherAPIHeaders,
    },
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function getOpportunitySpreadAPI(oppNo, financialYear) {
  return fetch(
    `${process.env.FINANCIAL_CLARITY_URL}/financial/pipeline/getOpportunitySpread?oppNo=${oppNo}&financialYear=${financialYear}`,
    {
      method: "GET",
      headers: otherAPIHeaders,
    },
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function getOpportunityGraphAPI(oppNo) {
  return fetch(
    `${process.env.FINANCIAL_CLARITY_URL}/financial/pipeline/getOpportunityGraph?oppNo=${oppNo}`,
    {
      method: "GET",
      headers: otherAPIHeaders,
    },
  )
    .then((res) => res.json())
    .catch((err) => err);
}
export function getExistingProjectIdAPI() {
  return fetch(
    `${process.env.FINANCIAL_CLARITY_URL}/financial/pipeline/listOfExistingProjectIds`,
    {
      method: "GET",
      headers: otherAPIHeaders,
    },
  )
    .then((res) => res.json())
    .catch((err) => err);
}
export function getSectorsAPI() {
  return fetch(
    `${process.env.FINANCIAL_CLARITY_URL}/financial/pipeline/listOfSectors`,
    {
      method: "GET",
      headers: otherAPIHeaders,
    },
  )
    .then((res) => res.json())
    .catch((err) => err);
}
export function getBusinessUnitsAPI() {
  return fetch(
    `${process.env.FINANCIAL_CLARITY_URL}/financial/pipeline/listOfBusinessUnits`,
    {
      method: "GET",
      headers: otherAPIHeaders,
    },
  )
    .then((res) => res.json())
    .catch((err) => err);
}
export function getOpportunityTypesAPI() {
  return fetch(
    `${process.env.FINANCIAL_CLARITY_URL}/financial/pipeline/listOfOpportunityTypes`,
    {
      method: "GET",
      headers: otherAPIHeaders,
    },
  )
    .then((res) => res.json())
    .catch((err) => err);
}
export function getAccountNamesAPI() {
  return fetch(
    `${process.env.FINANCIAL_CLARITY_URL}/financial/pipeline/listOfAccountNames`,
    {
      method: "GET",
      headers: otherAPIHeaders,
    },
  )
    .then((res) => res.json())
    .catch((err) => err);
}
export function getContractTypesAPI() {
  return fetch(
    `${process.env.FINANCIAL_CLARITY_URL}/financial/pipeline/listofcontracttypes`,
    {
      method: "GET",
      headers: otherAPIHeaders,
    },
  )
    .then((res) => res.json())
    .catch((err) => err);
}
export function getAwardTypesAPI() {
  return fetch(
    `${process.env.FINANCIAL_CLARITY_URL}/financial/pipeline/listofawardtypes`,
    {
      method: "GET",
      headers: otherAPIHeaders,
    },
  )
    .then((res) => res.json())
    .catch((err) => err);
}
export function getCompetitionTypesAPI() {
  return fetch(
    `${process.env.FINANCIAL_CLARITY_URL}/financial/pipeline/listofcompetitiontypes`,
    {
      method: "GET",
      headers: otherAPIHeaders,
    },
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function updateOpportunityLeadSpreadAPI(
  oppNo,
  transitionPeriod,
  spreadDuration,
) {
  return fetch(
    `${process.env.FINANCIAL_CLARITY_URL}/financial/pipeline/updateOpportunityLeadSpread?oppNo=${oppNo}&transitionPeriod=${transitionPeriod}&spreadDuration=${spreadDuration}`,
    {
      method: "POST",
      headers: otherAPIHeaders,
    },
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function updateOpportunitySpreadRevenueAPI(body) {
  return fetch(
    `${process.env.FINANCIAL_CLARITY_URL}/financial/pipeline/updateOpportunitySpreadRevenue`,
    {
      method: "POST",
      headers: otherAPIHeaders,
      body: JSON.stringify(body),
    },
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function addOpportunityAPI(body) {
  return fetch(
    `${process.env.FINANCIAL_CLARITY_URL}/financial/pipeline/addOpportunity`,
    {
      method: "POST",
      headers: otherAPIHeaders,
      body: JSON.stringify(body),
    },
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function updateOpportunityAPI(body) {
  return fetch(
    `${process.env.FINANCIAL_CLARITY_URL}/financial/pipeline/update`,
    {
      method: "PUT",
      headers: otherAPIHeaders,
      body: JSON.stringify(body),
    },
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function resourceListForClinAPI() {
  return fetch(
    `${process.env.FINANCIAL_CLARITY_URL}/financial/resourceListForClin`,
    {
      method: "GET",
      headers: otherAPIHeaders,
    },
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function clinForHeatMapAPI(contractId) {
  return fetch(
    `${process.env.FINANCIAL_CLARITY_URL}/financial/clinForHeatMap?contractId=${contractId}`,
    {
      method: "GET",
      headers: otherAPIHeaders,
    },
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function clinForExtraDetailsAPI(contractId) {
  return fetch(
    `${process.env.FINANCIAL_CLARITY_URL}/financial/clinForExtraDetails?contractId=${contractId}`,
    {
      method: "GET",
      headers: otherAPIHeaders,
    },
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function updateOpportunitySpreadTypeAPI(oppNo, spreadType) {
  return fetch(
    `${process.env.FINANCIAL_CLARITY_URL}/financial/pipeline/opportunitySpreadType?oppNo=${oppNo}&spreadType=${spreadType}`,
    {
      method: "PUT",
      headers: otherAPIHeaders,
    },
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function updateOpportunityTransitionSpreadAPI(body) {
  return fetch(
    `${process.env.FINANCIAL_CLARITY_URL}/financial/pipeline/updateOpportunityTransitionSpread`,
    {
      method: "POST",
      headers: otherAPIHeaders,
      body: JSON.stringify(body),
    },
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function deleteOpportunityAPI(oppNo) {
  return fetch(
    `${process.env.FINANCIAL_CLARITY_URL}/financial/pipeline/opportunity?oppNo=${oppNo}`,
    {
      method: "DELETE",
      headers: otherAPIHeaders,
    },
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function getOvertimeTypesAPI() {
  return fetch(`${process.env.FINANCIAL_CLARITY_URL}/financial/overtimeTypes`, {
    method: "GET",
    headers: otherAPIHeaders,
  })
    .then((res) => res.json())
    .catch((err) => err);
}

export function getContractDropdownAPI() {
  return fetch(
    `${process.env.FINANCIAL_CLARITY_URL}/financial/contract/contractDropdown`,
    {
      method: "GET",
      headers: otherAPIHeaders,
    },
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function getOvertimeTypesListAPI() {
  return fetch(
    `${process.env.FINANCIAL_CLARITY_URL}/financial/getOvertimeTypes`,
    {
      method: "GET",
      headers: otherAPIHeaders,
    },
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function updateOvertimeTypesAPI(body) {
  return fetch(
    `${process.env.FINANCIAL_CLARITY_URL}/financial/updateOvertimeTypes`,
    {
      method: "PUT",
      headers: otherAPIHeaders,
      body: JSON.stringify(body),
    },
  )
    .then((res) => res.json())
    .catch((err) => err);
}
